import React from 'react';
import ICON_PATHS from './paths';

interface RefIconProps {
  name: keyof typeof ICON_PATHS | string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

const RefIcon: React.FC<RefIconProps> = ({ name, size = 20, color = 'currentColor', strokeWidth = 1.7, className }) => {
  const d = ICON_PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={d} />
    </svg>
  );
};

export default RefIcon;
